import type { ReactElement, ReactNode } from 'react';

export interface FullPageMessageProps {
  title: string;
  detail?: string;
  children?: ReactNode;
}

/** Centred status surface for bootstrap, empty and hard-error states. */
export function FullPageMessage({ title, detail, children }: FullPageMessageProps): ReactElement {
  return (
    <div className="flex h-full items-center justify-center px-6">
      <div className="text-center">
        <p className="text-sm font-medium text-session-text">{title}</p>
        {detail ? <p className="mt-2 text-sm text-session-muted">{detail}</p> : null}
        {children ? <div className="mt-4">{children}</div> : null}
      </div>
    </div>
  );
}
